var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 16H4.27614C3.7713 16 3.51887 16 3.40199 15.9002C3.30056 15.8135 3.24674 15.6836 3.25721 15.5506C3.26927 15.3974 3.44776 15.2189 3.80474 14.8619L10.8905 7.77614C11.2205 7.44613 11.3855 7.28112 11.5758 7.2193C11.7432 7.16492 11.9235 7.16492 12.0908 7.2193C12.2811 7.28112 12.4461 7.44613 12.7761 7.77614L16 11V12M12 16C13.4001 16 14.1002 16 14.635 15.7275C15.1054 15.4878 15.4878 15.1054 15.7275 14.635C16 14.1002 16 13.4001 16 12M12 16H5C3.59987 16 2.8998 16 2.36502 15.7275C1.89462 15.4878 1.51217 15.1054 1.27248 14.635C1 14.1002 1 13.4001 1 12V5C1 3.59987 1 2.8998 1.27248 2.36502C1.51217 1.89462 1.89462 1.51217 2.36502 1.27248C2.8998 1 3.59987 1 5 1H12C13.4001 1 14.1002 1 14.635 1.27248C15.1054 1.51217 15.4878 1.89462 15.7275 2.36502C16 2.8998 16 3.59987 16 5V12M7.25 5.58333C7.25 6.50381 6.50381 7.25 5.58333 7.25C4.66286 7.25 3.91667 6.50381 3.91667 5.58333C3.91667 4.66286 4.66286 3.91667 5.58333 3.91667C6.50381 3.91667 7.25 4.66286 7.25 5.58333Z",
    stroke: "var(--stroke-0, #9F9F9F)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.3ac8c4803fee21a722c2228027d3dc92.svg";
export { ForwardRef as ReactComponent };